module.exports = __webpack_public_path__ + "static/img/son8_active.2a4303e6.png";